import "core-js/modules/es.array.slice.js";
import * as echarts from "echarts";
import { isEmpty } from "@/utils/shared";
export default {
  name: "PatientDivision",
  props: ["num", "max"],
  watch: {
    num: function num() {
      this.init();
    }
  },
  data: function data() {
    return {
      echart: null
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      if (isEmpty(this.$refs.instance)) return;
      this.echart = echarts.init(this.$refs.instance);
      this.echart.setOption({
        series: {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          center: ["50%", "75%"],
          radius: "100%",
          min: 0,
          max: 1,
          splitNumber: 8,
          axisLine: {
            lineStyle: {
              width: 6,
              color: [[0.25, "#7CFFB2"], [0.5, "#58D9F9"], [0.75, "#FDDD60"], [1, "#FF6E76"]]
            }
          },
          pointer: {
            icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
            length: "12%",
            width: this.size(12),
            offsetCenter: [0, "-60%"],
            itemStyle: {
              color: "auto"
            }
          },
          axisTick: {
            length: this.size(8),
            lineStyle: {
              color: "auto",
              width: this.size(2)
            }
          },
          splitLine: {
            length: this.size(16),
            lineStyle: {
              color: "auto",
              width: this.size(4)
            }
          },
          title: {
            offsetCenter: [0, 0],
            fontSize: this.size(20)
          },
          detail: {
            fontSize: this.size(32),
            offsetCenter: [0, "-25%"],
            valueAnimation: true,
            formatter: function formatter() {
              return _this.num;
            },
            color: "inherit"
          },
          data: [{
            value: this.num / this.max,
            name: "mmHg"
          }]
        }
      });
    },
    size: function size(sz) {
      return sz / 14 * document.documentElement.style.fontSize.slice(0, -2);
    }
  }
};